import { useState } from 'react';
import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import d from '../FetchDesign.module.css';
import { FETCH_WELCOME_URL } from '../constants';
import { useFetchDesign } from '../fetchDesign';
import { FetchLogo } from './FetchLogo';

interface FetchOfferPanelProps {
  isMobile?: boolean;
}

const BENEFITS = [
  'Covers up to 90% of unexpected vet bills',
  'Use any vet in the U.S. or Canada',
  'Customize your price to fit your budget',
];

export function FetchOfferPanel({ isMobile }: FetchOfferPanelProps) {
  const theme = useTheme();
  const { hero, heading, sub } = useFetchDesign();
  const [benefitsOpen, setBenefitsOpen] = useState(false);
  const showBenefits = !isMobile || benefitsOpen;

  return (
    <div className={styles.offerPanel}>
      <div className={styles.offerPanelHead}>
        <FetchLogo />
        {isMobile && (
          <div
            className={`${styles.heroThumb} ${d.art}`}
            data-hero={hero}
            aria-hidden
          />
        )}
      </div>

      <div className={styles.offerCopy}>
        <h3
          className={styles.offerHeading}
          style={{ fontFamily: theme.headersMediumNone?.fontFamily }}
        >
          {heading}
        </h3>
        <p className={styles.offerSub}>{sub}</p>
      </div>

      {isMobile && (
        <button
          type="button"
          className={styles.benefitsToggle}
          aria-expanded={benefitsOpen}
          onClick={() => setBenefitsOpen((open) => !open)}
        >
          See all benefits
          <span
            aria-hidden
            className={styles.benefitsChevron}
            data-open={benefitsOpen ? 'true' : 'false'}
          >
            ⌄
          </span>
        </button>
      )}

      {showBenefits && (
        <>
          <ul className={styles.benefits}>
            {BENEFITS.map((benefit) => (
              <li key={benefit} className={styles.benefit}>
                <span className={styles.benefitCheck} aria-hidden>
                  ✓
                </span>
                <span>{benefit}</span>
              </li>
            ))}
          </ul>

          <a
            className={styles.coverageLink}
            href={FETCH_WELCOME_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            See what&apos;s covered
          </a>
        </>
      )}

      {!isMobile && (
        <div
          className={`${styles.hero} ${d.art}`}
          data-hero={hero}
          aria-hidden
        />
      )}
    </div>
  );
}
